import styled from "styled-components";
import { Box } from "rebass";

export const UL = styled(Box)`
  list-style: none;
  padding-inline-start: unset;
`;

UL.defaultProps = {
  as: "ul",
};
